/** Bump when Terms or Privacy content materially changes (stored on user profile at signup). */
export const LEGAL_DOC_VERSION = '2026-07-27';
